import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { connect } from '../../hoc';

function SeekBackground({ ongoingSeek, width, seekBackground = {} }) {
  const [thumbnailStyle, setThumbnailStyle] = useState({});

  useEffect(() => {
    const scale = width / seekBackground.width;
    const translate = (0.5 - (1 / (2 * scale))) * 100;

    setThumbnailStyle({
      ...{
        zIndex: -1,
        display: ongoingSeek ? 'block' : 'none',
        position: 'absolute',
        background: 'transparent',
        backgroundSize: 'cover',
        backgroundPosition: `-${seekBackground?.x || 0}px -${seekBackground?.y || 0}px`,
        transform: `scale(${scale}) translateX(${translate}%) translateY(${translate}%)`,
        width: seekBackground.width,
        height: seekBackground.height
      },
      ...seekBackground?.url && { background: `url("${seekBackground?.url}") no-repeat` }
    });
  }, [seekBackground.x, seekBackground.y, seekBackground.url, seekBackground.width, ongoingSeek]);

  return (
    <div style={thumbnailStyle} />
  );
}

const selector = (store) => {
  const { playback, ui } = store;
  const { ongoingSeek } = playback;
  const { width, seekBackground } = ui;

  return {
    ongoingSeek,
    width,
    seekBackground
  };
};

export default connect(selector)(SeekBackground);
